import api from '../../../../services/api';
import { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import { useForm } from "react-hook-form";
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import PageContainer from '../../../../common/components/PageContainer';
import useAlerta from '../../../../common/components/useAlerta';
import AppSnackbar from '../../../../common/components/AppSnackbar';

function OrcamentoItem() {
    const [orcamento, setOrcamento] = useState({});
    const [solicitante, setSolicitante] = useState({});
    const [itens, setItens] = useState([]);
    const [sc, setSC] = useState({});
    const { id, idOrcamento } = useParams();
    const { alerta, mostrarAlerta, fecharAlerta } = useAlerta();
    const { register, handleSubmit } = useForm();

    useEffect(() => {
        async function fetchData() {
            try {
                const responseSC = await api.get(`/sc/${id}`);
                setSC(responseSC.data);

                const responseOrc = await api.get(`/sc/${id}/orcamento/${idOrcamento}`);
                setOrcamento(responseOrc.data);

                const responseitens = await api.get(`/sc/${id}/orcamento/${idOrcamento}/itens`);
                setItens(responseitens.data);
            } catch (error) {
                console.error('Erro ao buscar as informações!', error);
            }
        }
        fetchData();
    }, [id, idOrcamento]);

    useEffect(() => {
        if (sc?.solicitante) {
            async function fetchSolicitante() {
                try {
                    const responseSol = await api.get(`/funcionario/${sc.solicitante}`);
                    setSolicitante(responseSol.data);
                } catch (error) {
                    console.error('Erro ao buscar o solicitante!', error);
                }
            }
            fetchSolicitante();
        }
    }, [sc]);

    const onSubmit = async (data) => {
        const formData = {
            ...data,
            idOrcamentoSelecionado: idOrcamento,
        };

        try {
            await api.put(`/sc/${id}`, formData);
            mostrarAlerta('Solicitação de compra aprovada!', 'success');
            setTimeout(() => {
                window.location.href = '/sc';
            }, 1500);
        } catch (error) {
            mostrarAlerta('Erro ao aprovar solicitação de compra!', 'error');
        }
        setTimeout(fecharAlerta, 3000);
    };

    return (
        <PageContainer sx={{ maxWidth: 700 }}>
            <Paper component="form" onSubmit={handleSubmit(onSubmit)} sx={{ p: { xs: 2, sm: 4 } }}>
                <Typography variant="h5" sx={{ color: 'primary.main', fontWeight: 600, mb: 3 }}>
                    Análise de orçamento
                </Typography>

                <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                    Solicitação de compra
                </Typography>
                <Grid container spacing={1} sx={{ mb: 2 }}>
                    <Grid item xs={12} sm={6}><Typography variant="body2">Motivo: {sc.motivo}</Typography></Grid>
                    <Grid item xs={12} sm={6}><Typography variant="body2">Prioridade: {sc.prioridade}</Typography></Grid>
                    <Grid item xs={12} sm={6}><Typography variant="body2">Solicitante: {solicitante.nome}</Typography></Grid>
                    <Grid item xs={12} sm={6}><Typography variant="body2">Setor: {sc.setor}</Typography></Grid>
                    <Grid item xs={12}>
                        <Typography variant="body2">
                            Prazo de entrega: {orcamento.prazoEntrega === 0 ? 'Imediato' : orcamento.prazoEntrega === 1 ? '1 Dia' : `${orcamento.prazoEntrega} Dias`}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}><Typography variant="body2">Informações adicionais: {sc.infAdicionais}</Typography></Grid>
                </Grid>

                <Divider sx={{ my: 2 }} />

                <Stack spacing={1.5} sx={{ mb: 2 }}>
                    {itens.map((item) => (
                        <Box key={item.id}>
                            <Typography variant="body2">Descrição: {item.descricao}</Typography>
                            <Typography variant="body2">Quantidade: {item.quantidade}</Typography>
                            <Typography variant="body2">Valor Unitário: {item.valorUnitario.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</Typography>
                            <Typography variant="body2">Valor Total: {(item.quantidade * item.valorUnitario).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</Typography>
                        </Box>
                    ))}
                </Stack>

                <Typography variant="h6" sx={{ mb: 2 }}>
                    Total: {orcamento && orcamento.valor !== undefined
                        ? orcamento.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                        : 'Carregando...'}
                </Typography>

                <TextField
                    {...register("comentario")}
                    label="Comentário"
                    fullWidth
                    sx={{ mb: 3 }}
                />

                <Stack direction="row" spacing={2} justifyContent="center">
                    <Button type="submit" variant="contained" color="secondary" size="large">
                        Aprovar orçamento
                    </Button>
                    <Button variant="outlined" size="large" onClick={() => { window.location.href = `/sc/${id}/orcamento`; }}>
                        Voltar
                    </Button>
                </Stack>
            </Paper>

            <AppSnackbar alerta={alerta} onClose={fecharAlerta} />
        </PageContainer>
    );
}

export default OrcamentoItem;
